/**
 * @file src/shell/ErrorScreen.js
 * Màn hình lỗi theo error code + fallback tĩnh khi không có WebGL2.
 *
 * Vì sao có fallback tĩnh: khoảng 1% thiết bị không hỗ trợ WebGL2 — với hàng
 * trăm nghìn học sinh thì đó vẫn là hàng nghìn em. Làm WebGL1 fallback quá đắt
 * để duy trì; hiện poster + nội dung text thì các em VẪN ĐỌC ĐƯỢC bài.
 */

/**
 * @param {HTMLElement} root
 * @param {{code: string, message: string, retryable: boolean, onRetry?: () => void}} o
 * @returns {() => void} hàm gỡ
 */
export function showErrorScreen(root, o) {
  const el = document.createElement('div');
  el.className = 'ol-error';
  el.innerHTML = `
    <div class="ol-error__box">
      <div class="ol-error__msg"></div>
      <div class="ol-error__code"></div>
      ${o.retryable ? '<button class="ol-btn ol-error__retry"></button>' : ''}
    </div>`;
  /** @type {HTMLElement} */ (el.querySelector('.ol-error__msg')).textContent = o.message;
  /** @type {HTMLElement} */ (el.querySelector('.ol-error__code')).textContent = o.code;

  const retry = el.querySelector('.ol-error__retry');
  if (retry) {
    retry.textContent = 'Thử lại';
    retry.addEventListener('click', () => (o.onRetry ? o.onRetry() : location.reload()));
  }

  root.appendChild(el);
  return () => el.remove();
}

/**
 * Fallback khi không thể render 3D. Hiện poster + tiêu đề + mô tả từ content/index.
 * @param {HTMLElement} root
 * @param {{messageKey: string, t: (k: string) => string, info: Record<string, any>}} o
 */
export function showStaticFallback(root, o) {
  const lang = 'vi';
  const title = o.info?.title?.[lang] ?? '';
  const desc = o.info?.description?.[lang] ?? '';
  const poster = o.info?.poster ?? 'poster.jpg';

  const el = document.createElement('div');
  el.className = 'ol-fallback';
  el.innerHTML = `
    <img class="ol-fallback__poster" alt="" />
    <div class="ol-fallback__body">
      <h1></h1>
      <p class="ol-fallback__desc"></p>
      <p class="ol-fallback__warn"></p>
    </div>`;
  /** @type {HTMLImageElement} */ (el.querySelector('.ol-fallback__poster')).src = poster;
  /** @type {HTMLElement} */ (el.querySelector('h1')).textContent = title;
  /** @type {HTMLElement} */ (el.querySelector('.ol-fallback__desc')).textContent = desc;
  /** @type {HTMLElement} */ (el.querySelector('.ol-fallback__warn')).textContent = o.t(
    o.messageKey,
  );

  root.appendChild(el);
}
